import React from 'react'

export const CarIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#E5C265', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    stroke={color}
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M5 17h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2z' />
    <path d='M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.1-1.3-.5-1.7L17 7h-1' />
    <path d='M5 17H3c-.6 0-1-.4-1-1v-3c0-.9.1-1.3.5-1.7L7 7h1' />
    <circle cx='7' cy='17' r='2' />
    <circle cx='17' cy='17' r='2' />
  </svg>
)
